import './image_upload_input.scss'

export function configureImageUploadComponent(element: HTMLElement) {
  const fileInput =
    element.querySelector<HTMLInputElement>('.custom-file-input')

  if (!fileInput) {
    return
  }

  fileInput.addEventListener('change', function () {
    if (!fileInput.files) {
      return
    }

    const url = URL.createObjectURL(fileInput.files[0])

    const imagePreviewElement =
      element.querySelector<HTMLImageElement>('.image-preview')
    if (!imagePreviewElement) {
      return
    }

    imagePreviewElement.classList.remove('d-none')
    element.querySelector('.image-placeholder')?.classList.add('d-none')

    imagePreviewElement.src = url
  })
}

export function configureImageUploadComponents() {
  document.querySelectorAll('.image-upload-component').forEach((element) => {
    configureImageUploadComponent(element as HTMLElement)
  })
}
